import { Controller } from 'lib/stimulus-instance'

export default class CookiesAcceptanceMessage extends Controller {
  static values = {
    disabled: Boolean, // default false
    forcedAcceptance: Boolean, // default false
  }

  connect () {
    this.#handleForcedAcceptance()
    if (this.shouldShowMessage) {
      this.show()
    } else {
      this.remove()
    }
  }

  dismiss () {
    this.cookiesAccepted = true
    this.letEveryoneKnow()
    this.remove()
  }

  remove () {
    this.withAnimation(() => { this.element.classList.add('collapsed') })
    setTimeout(() => { this.element.remove() }, 700)
  }

  show () {
    if (!this.element.classList.contains('collapsed')) return
    this.withAnimation(() => { this.element.classList.remove('collapsed') })
  }

  withAnimation (block) {
    this.element.classList.add('is_animating')
    setTimeout(() => {
      block()
      setTimeout(() => {
        this.element.classList.remove('is_animating')
      }, 300)
    }, 300)
  }

  letEveryoneKnow () {
    document.dispatchEvent(new Event('cookies:accepted:all'))
  }

  #handleForcedAcceptance () {
    if (this.forcedAcceptanceValue) {
      this.dismiss()
    }
  }

  get shouldShowMessage () {
    return !this.disabledValue && !this.cookiesAccepted
  }

  get cookiesAccepted () {
    return this.storage?.getItem('cookiesAccepted') === 'true'
  }

  set cookiesAccepted (value) {
    this.storage.setItem('cookiesAccepted', value ? 'true' : 'false')
  }

  get storage () {
    return window.localStorage
  }
}
